module.exports = __webpack_public_path__ + "media/images/result_sets/circles/7r8r5r1r-d0ddf0904db2886bbbd3915c84921400.svg";